import React from 'react';
import classNames from 'classnames';

import { AnimatedCard } from 'apps/discover/components/AnimatedCard';
import { FollowUserButton } from 'components/users/FollowUserButton';

import * as Types from 'types';

export type Props = {
  user: Types.UserCard;
  className?: string;
  onMount?: (ref: React.RefObject<HTMLAnchorElement>) => void;
};

const UserStat: React.FC<{
  label: string;
  value: string | number | undefined;
}> = ({ label, value }) => {
  return (
    <div className='user-stats__column'>
      <div className='user-stats__stat'>
        <dt>{label}</dt>
        <dd>{value}</dd>
      </div>
    </div>
  );
};

export const UserComponent: React.FC<Props> = ({ user, onMount, className }: Props) => {
  const ref = React.createRef<HTMLAnchorElement>();
  React.useEffect(() => {
    onMount ? onMount(ref) : undefined;
  }, []);

  const userId = user.id;

  return (
    <AnimatedCard className={classNames('user-component', className)}>
      <a ref={ref} className='user-component__avatar' href={user.url}>
        <img alt={`${user.name} avatar`} className='avatar' src={user.avatarUrl} />
        <dl className='user-stats'>
          {user.artist ? <UserStat label='Artworks' value={user.artist.artworksCount} /> : null}
          {user.artist ? <UserStat label='Collectors' value={user.artist.collectorsCount} /> : null}
          {!user.artist ? (
            <UserStat
              label='Following'
              value={user.followingCount === undefined ? 'N/A' : user.followingCount}
            />
          ) : null}
          <UserStat label='Followers' value={user.followersCount} />
          {!user.artist ? <UserStat label='Collected' value={user.editionsCount} /> : null}
        </dl>
        <div className='user-component__top-right'>
          <FollowUserButton userId={user.id} />
        </div>
      </a>
      <figcaption className='user-component__name'>
        <a className='artist-name' href={user.url}>
          {user.name}
        </a>
      </figcaption>
    </AnimatedCard>
  );
};
